import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUserState } from '../../interfaces/state.interfaces';
import { IUser, IUserExceptId } from '../../interfaces/user.interface';
import { UserStage } from '../../constants/user.constant';

const initialState: IUserState = {
    id: null,
    name: null,
    email: null,
    stage: UserStage.NEW,
    currentlyWorkingBrandId: null,
    apiStatus: null,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        SetUserDetails(state, action: PayloadAction<IUser>) {
            state.id = action.payload.id;
            state.name = action.payload.name;
            state.email = action.payload.email;
            state.stage = action.payload.stage;
            state.currentlyWorkingBrandId = action.payload.currentlyWorkingBrandId;
            state.apiStatus = action.payload.apiStatus;
        },
        SetUserDetailsExceptId(state, action: PayloadAction<IUserExceptId>) {
            state.name = action.payload.name;
            state.email = action.payload.email;
            state.stage = action.payload.stage;
            state.currentlyWorkingBrandId = action.payload.currentlyWorkingBrandId;
            state.apiStatus = action.payload.apiStatus;
        },
        SetUserOld(state) {
            state.stage = UserStage.OLD;
        },
        SetUserCurrentlyWorkingBrandId(state, action: PayloadAction<number | null>) {
            state.currentlyWorkingBrandId = action.payload;
        },
        SetApiStatus(state, action: PayloadAction<boolean | null>) {
            state.apiStatus = action.payload;
        },
        SetUserInitialState(state) {
            state.id = null;
            state.name = null;
            state.email = null;
            state.currentlyWorkingBrandId = null;
            state.apiStatus = null;
        },
    },
});

export const {
    SetUserDetails,
    SetUserDetailsExceptId,
    SetUserOld,
    SetUserCurrentlyWorkingBrandId,
    SetApiStatus,
    SetUserInitialState,
} = userSlice.actions;

export const userReducer = userSlice.reducer;
